/**
 * TagList Component
 * Bordered tag chips matching Figma design:
 * border #f2f0eb, rounded-lg, px-2.5 py-2, 13px text
 */

import { TagChip } from "@/components/shared/TagChip"
import type { SearchTab } from "@/features/search/types/search.types"
import { useIsMobile } from "@/hooks/useIsMobile"

const DESKTOP_MAX_VISIBLE = 3
const MOBILE_MAX_VISIBLE = 2

interface TagListProps {
  tags: string[]
  maxVisible?: number
  className?: string
  searchTab?: SearchTab
}

export function TagList({ tags, maxVisible, className, searchTab }: TagListProps) {
  const isMobile = useIsMobile()

  if (tags.length === 0) return null

  const resolvedMax = maxVisible ?? (isMobile ? MOBILE_MAX_VISIBLE : DESKTOP_MAX_VISIBLE)

  const visibleTags = tags.slice(0, resolvedMax)
  const overflowCount = tags.length - resolvedMax

  return (
    <div className={`flex items-center gap-2.5 ${className ?? ""} flex-wrap`}>
      {visibleTags.map(tag =>
        searchTab ? (
          <TagChip key={tag} tag={tag} tab={searchTab} />
        ) : (
          <span
            key={tag}
            className="border border-text-primary rounded-md px-2.5 py-2 text-[13px] text-text-primary leading-[20px] whitespace-nowrap"
          >
            {tag}
          </span>
        ),
      )}
      {overflowCount > 0 && (
        <span className="text-sm text-text-primary leading-[20px]">+{overflowCount}</span>
      )}
    </div>
  )
}
